import { Validator } from '@vista-digital/validator';
import { iconAssetValidator } from '../../../../../../validators/icon-asset';
export const defaultJourneyActionButtonGooglePayAssets = {
    icon: {
        name: 'save-to-google-pay-button',
        viewBox: '0 0 288 44'
    }
};
export const journeyActionButtonGooglePayAssetsValidator = Validator.object({
    icon: iconAssetValidator
});
